import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn
} from '@angular/forms';
import { isStringNotEmpty } from '@core/utils/string';

export function billingAddress(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        let isValid: boolean = true;
        let errors: any = {};

        const formItem = (control as FormGroup);
        const formLine1Item: FormControl = formItem.get('line1') as FormControl;
        const formCityItem: FormControl = formItem.get('city') as FormControl;
        const formStateItem: FormControl = formItem.get('state') as FormControl;
        const formPostalCodeItem: FormControl = formItem.get('postal_code') as FormControl;
        const formCountryItem: FormControl = formItem.get('country') as FormControl;

        if (formLine1Item && !isStringNotEmpty(formLine1Item.value)) {
            isValid = false;
            errors.line1 = true;
        }

        if (formCityItem && !isStringNotEmpty(formCityItem.value)) {
            isValid = false;
            errors.city = true;
        }

        if (formStateItem && !isStringNotEmpty(formStateItem.value)) {
            isValid = false;
            errors.state = true;
        }

        if (formPostalCodeItem && !isStringNotEmpty(formPostalCodeItem.value)) {
            isValid = false;
            errors.postalCode = true;
        }

        if (formCountryItem && !isStringNotEmpty(formCountryItem.value)) {
            isValid = false;
            errors.country = true;
        }

        return (isValid) ? null: errors;
    }
}
